interface CategoryGroupHeaderProps {
    name: string;
    count: number;
    variant?: 'band' | 'sticky';
    inCountLabel?: string;
}

export default function CategoryGroupHeader({
    name,
    count,
    variant = 'band',
    inCountLabel,
}: CategoryGroupHeaderProps) {
    if (variant === 'sticky') {
        return (
            <div
                className="flex items-center sticky top-0 z-[2]"
                style={{
                    gap: 10,
                    padding: '9px 14px',
                    borderTop: '1px solid var(--cpm-border-strong)',
                    borderBottom: '1px solid var(--cpm-border-default)',
                    background: 'var(--cpm-purple-tint-13)',
                }}
            >
                <span
                    style={{
                        fontSize: 11,
                        fontWeight: 800,
                        letterSpacing: '0.09em',
                        textTransform: 'uppercase',
                        color: 'var(--cpm-brand-navy)',
                    }}
                >
                    {name}
                </span>
                <span
                    className="inline-flex items-center justify-center"
                    style={{
                        minWidth: 20,
                        height: 20,
                        padding: '0 6px',
                        borderRadius: 'var(--cpm-radius-full)',
                        background: '#fff',
                        border: '1px solid var(--cpm-brand-purple)',
                        fontSize: 11,
                        fontWeight: 800,
                        color: 'var(--cpm-brand-navy)',
                    }}
                >
                    {count}
                </span>
                <span style={{ height: 1, flex: 1, background: 'rgba(110, 100, 240, 0.28)' }} />
                {inCountLabel ? (
                    <span
                        style={{
                            fontSize: 10.5,
                            fontWeight: 800,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: 'var(--cpm-text-secondary)',
                        }}
                    >
                        {inCountLabel}
                    </span>
                ) : null}
            </div>
        );
    }

    return (
        <div
            className="flex items-center justify-between"
            style={{
                gap: 12,
                padding: '9px 16px',
                background: 'var(--cpm-purple-tint-7)',
                borderBottom: '1px solid var(--cpm-border-default)',
            }}
        >
            <span
                style={{
                    fontSize: 10,
                    fontWeight: 800,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    color: 'var(--cpm-brand-navy)',
                }}
            >
                {name}
            </span>
            <span
                style={{
                    padding: '2px 9px',
                    borderRadius: 'var(--cpm-radius-full)',
                    background: 'var(--cpm-purple-tint-13)',
                    fontSize: 11,
                    fontWeight: 800,
                    color: 'var(--cpm-brand-purple)',
                    fontVariantNumeric: 'tabular-nums',
                }}
            >
                {count}
            </span>
        </div>
    );
}
